<script>
import Titre from "@/components/atoms/titre";
import ButtonIcon from "@/components/molecules/button-icon";
import { storeLocatorEmits, storeLocatorProps, useStoreLocator } from "./mixin";

import pictoStorelocEasybox from "@/assets/images/picto-storeloc-easybox.svg";
import pictoStorelocLaposte from "@/assets/images/picto-storeloc-laposte.svg";
import pictoStorelocCev from "@/assets/images/picto-storeloc-cev.svg";
import pinR from "@/assets/images/pin-r.svg";
import placeholderCora from "@/assets/images/placeholder-cora.svg";
import placeholderCarrefour from "@/assets/images/placeholder-carrefour.png";

export default {
  name: "StoreLocator",
  components: {
    Titre,
    ButtonIcon
  },
  props: {
    ...storeLocatorProps()
  },
  emits: ["closed", ...storeLocatorEmits()],
  setup(props, context) {
    const {
      storeLocatorHeight,
      storeStyleHeight,
      isLegendShown,
      initWoosmapScript,
      beforeUnmount
    } = useStoreLocator(props, context);

    onMounted(async () => {
      storeLocatorHeight.value = window.innerHeight - 90;
      await initWoosmapScript(true);
    });

    onBeforeUnmount(beforeUnmount);

    return {
      storeLocatorHeight,
      storeStyleHeight,
      isLegendShown,
      initWoosmapScript,
      pictoStorelocEasybox,
      pictoStorelocLaposte,
      pictoStorelocCev,
      pinR,
      placeholderCora,
      placeholderCarrefour
    };
  }
};
</script>

<template>
  <div class="c-storelocator__container">
    <Titre
      tag="h2"
      class="c-storelocator__title u-text-center u-mb-xs u-mt-xs"
    >
      Trouver mon magasin
    </Titre>
    <div
      id="store-locator"
      class="c-storelocator"
      :style="storeStyleHeight"
    />
    <div class="c-storelocator__legend-button-container">
      <ButtonIcon
        variant="secondary"
        icon-name="info-circle"
        icon-color="white"
        icon-size="xs"
        size="sm"
        radius="full"
        @click="isLegendShown = !isLegendShown"
      >
        Légende
      </ButtonIcon>
    </div>
    <div
      class="c-storelocator__legend u-box-shadow-lg u-pt-md"
      :class="isLegendShown && 'c-storelocator-mobile__legend-shown'"
    >
      <div class="c-storelocator__legend-item">
        <img
          :src="placeholderCarrefour"
          width="32"
          height="32"
        />
        Hypermarché - Commande sur carrefour.fr
      </div>
      <div class="c-storelocator__legend-item">
        <img
          :src="placeholderCora"
          width="32"
          height="32"
        />
        Hypermarché - Commande sur cora.fr
      </div>
      <div class="c-storelocator__legend-item">
        <img
          :src="pinR"
          width="32"
          height="32"
        />
        Point de retrait commerçant
      </div>
      <div class="c-storelocator__legend-item">
        <img
          :src="pictoStorelocCev"
          width="32"
          height="32"
        />
        Drive piéton
      </div>
      <!-- <div class="c-storelocator__legend-item">
        <img
          :src="pictoStorelocEasybox"
          width="32"
          height="32"
        />
        Easybox
      </div>
       <div class="c-storelocator__legend-item">
        <img
          :src="pictoStorelocLaposte"
          width="32"
          height="32"
        />
        La poste
      </div> -->
      <div class="c-storelocator__legend-close">
        <ButtonIcon
          icon-color="text-light"
          icon-color-hover="primary-light"
          size="sm"
          icon-size="sm"
          icon-name="cross"
          aria-label="Fermer la légende"
          @click="isLegendShown = false"
        />
      </div>
    </div>
    <div class="c-storelocator__close">
      <ButtonIcon
        icon-color="text-light"
        icon-color-hover="primary-light"
        size="sm"
        icon-size="sm"
        icon-name="cross"
        aria-label="Fermer la popin"
        @click="$emit('closed');"
      />
    </div>
  </div>
</template>

<style lang="scss">
@import "@/assets/styles/components/header-store-locator-mobile.scss";
</style>
